// Contexto legado: agora apenas expõe o MESMO socket namespaced criado em useAuth (SocketWorker)
import { createContext } from "react";

// Estratégia:
// - useAuth cria uma conexão única namespaced ( /:companyId ) e a coloca em window.__APP_SOCKET
// - Este manager apenas devolve essa instância, sem jamais criar nova conexão.
// - Mantemos API compatível (GetSocket, onConnect) para código antigo.

function resolveExistingSocket() {
	if (typeof window !== "undefined" && window.__APP_SOCKET) {
		return window.__APP_SOCKET;
	}
	return null;
}

const socketManager = {
	GetSocket() {
		const s = resolveExistingSocket();
		if (!s && process.env.NODE_ENV !== "production") {
			// Aviso apenas em dev para detectar usos antes da auth finalizar
			if (!window.__SOCKET_CTX_WARNED) {
				window.__SOCKET_CTX_WARNED = true;
				// eslint-disable-next-line no-console
				console.warn("[SocketContext] Socket ainda não disponível. Aguarde autenticação.");
			}
		}
		return s;
	},
	EnsureCompanySocket() { // compat legado
		return this.GetSocket();
	},
	GetCompanySocket() { // compat legado
		return this.GetSocket();
	},
	onConnect(cb) {
		const s = this.GetSocket();
		if (!s) return;
		if (s.connected) cb();
		s.on("connect", cb);
	}
};

const SocketContext = createContext({
	GetSocket: () => null,
	EnsureCompanySocket: () => null
});

export { SocketContext, socketManager };
